export var TERMS_VERSION = '2024-07-01';
export var PRIVACY_POLICY_VERSION = '2024-07-01';